import { useState } from 'react';
import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type RecaptchaProps = {
    recaptchaValidated: boolean;
    setRecaptchaValidated: ReactSetState<boolean>
}

const [useRecaptchaContext, Provider] = createContext<RecaptchaProps>('RecaptchaCtx');

const useInitRecaptchaContext = () => {
    const [recaptchaValidated, setRecaptchaValidated] = useState<boolean>(false)

    const recaptchaProps: RecaptchaProps = {
        recaptchaValidated,
        setRecaptchaValidated
    };
    return recaptchaProps;
};

const RecaptchaContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitRecaptchaContext()}>
        {children}
    </Provider>;
};

export { useRecaptchaContext, RecaptchaContextProvider };